"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var identityVerificationContainerStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        root: (_b = {
                position: 'relative'
            },
            _b[breakpoints.down('sm')] = {
                padding: 5,
            },
            _b),
    });
}, { name: 'Checkout4_IdentityVerification' });
exports.default = identityVerificationContainerStyles;
